import { makeAutoObservable } from 'mobx';
import { UserSummaryType } from '../api/types/user/user-summary.type';
import { UpdateUserPermission } from '../api/types/user/permissions/update-user-permission-request';
import { UserPermissionType } from '../api/types/user/permissions/user-permission-type';
import { UserPermissionValue } from '../api/types/user/permissions/user-permission-value';
import { SettingsBranches } from '../api/types/settings/branches/settings-branches';
import { UserDetailsDb } from '../api/types/home-data/home-data';
import appApi from '../api/app-api';

interface RootFilter {
  currentBranches?: SettingsBranches;
}

class GlobalConfigStore {
  cities: string[] = [];
  baseFileUrl = '';
  isReady = false;
  userDetails!: UserDetailsDb;
  user: UserSummaryType | null = null;
  permissions: UpdateUserPermission = {
    branchesPermissions: [
      {
        branch: {
          id: 1,
          branchName: 'ירושלים - גברים',
          buildings: [],
          createdByName: 'asdasd',
          createdAt: new Date(),
          createdBy: 1,
        },
        isAllow: true,
      },

      {
        branch: {
          id: 2,
          branchName: 'ירושלים - גברים2',
          buildings: [],
          createdByName: 'asdasd',
          createdAt: new Date(),
          createdBy: 1,
        },
        isAllow: false,
      },

      {
        branch: {
          id: 3,
          branchName: 'ירושלים - גברים3',
          buildings: [],
          createdByName: 'asdasd',
          createdAt: new Date(),
          createdBy: 1,
        },
        isAllow: true,
      },
      {
        branch: {
          id: 4,
          branchName: 'ירושלים - גברים4',
          buildings: [],
          createdByName: 'asdasd',
          createdAt: new Date(),
          createdBy: 1,
        },
        isAllow: true,
      },
    ],
    permissions: [
      {
        type: UserPermissionType.SETTINGS,
        value: UserPermissionValue.WRITE,
      },
      {
        type: UserPermissionType.SETTINGS_BRANCHES,
        value: UserPermissionValue.NONE,
      },
      {
        type: UserPermissionType.FINANCIAL_REPORTS,
        value: UserPermissionValue.READ,
      },
      {
        type: UserPermissionType.ACCOUNTING,
        value: UserPermissionValue.READ,
      },
      {
        type: UserPermissionType.EDUCATION,
        value: UserPermissionValue.READ,
      },
      {
        type: UserPermissionType.REGISTRATION_AND_COLLECTION,
        value: UserPermissionValue.READ,
      },
    ],
  };
  rootFilter: RootFilter = {};
  constructor() {
    makeAutoObservable(this); // This automatically makes everything observable
  }

  getCities = async () => {
    if (this.cities.length === 0) {
      const citiesRes = await appApi.getCities();

      const cities = citiesRes.data.result.records.map(
        (item) => item.name_in_hebrew,
      );

      this.cities = cities;
    }
    return this.cities;
  };
}

const globalConfigStore = new GlobalConfigStore();
export default globalConfigStore;
